/* Replace cart line-item thumbnails with the personalised preview URLs
   that Customily / Customall save in their cart line item properties.
   Works with the SlideCartHQ drawer (renders to .slidecarthq) and any
   /cart page that uses .item-image-anchor / .cart-item__image. */
(function () {
  var LOG = '[cart-thumb-override]';

  /* Property-name hints that point to a "thumb-sized" preview. Ordered
     by preference — a thumb URL is preferred over a full-size preview
     when both exist. */
  var THUMB_NAME_RANK = [
    /^_customily-thumb$/i,
    /^_customall.*thumb/i,
    /^_ctm.*thumb/i,
    /^_pb.*thumb/i,
    /^_thumb/i,
    /^_customily-preview$/i,
    /^_customall.*(preview|mockup)/i,
    /^_ctm.*(preview|mockup)/i,
    /^_pb.*(preview|mockup)/i,
    /^_preview/i,
    /^_mockup/i,
    /^_personalized-?(thumb|image|preview|mockup)/i,
    /^_artwork.*url/i,
    /^_design.*image/i,
  ];

  /* Last-resort: any underscore-prefixed property whose value is an
     HTTPS URL pointing to an image-like asset on an app CDN. */
  function looksLikeImageUrl(val) {
    if (typeof val !== 'string') return false;
    if (!/^https?:\/\//.test(val)) return false;
    return /\.(jpe?g|png|webp|gif|svg)(\?|$)/i.test(val) ||
           /\/(preview|thumb|mockup|design|artwork|render|file)s?\//i.test(val) ||
           /customall\.io|customily\.com|customilyhq/i.test(val);
  }

  function pickThumb(properties) {
    if (!properties) return null;
    /* Try named patterns first, in preference order. */
    for (var pattern of THUMB_NAME_RANK) {
      for (var key in properties) {
        if (pattern.test(key)) {
          var v = properties[key];
          if (typeof v === 'string' && v.indexOf('http') === 0) return v;
        }
      }
    }
    /* Fallback: any underscore-prefixed property with an image-like URL. */
    for (var key in properties) {
      if (key[0] !== '_') continue;
      if (looksLikeImageUrl(properties[key])) return properties[key];
    }
    return null;
  }

  async function overrideImages() {
    try {
      var r = await fetch('/cart.js', { credentials: 'same-origin' });
      var cart = await r.json();
      var items = cart.items || [];
      if (!items.length) return;

      /* Try each likely cart line-item container/image selector. */
      var containerSelectors = [
        '.slidecarthq .item-container',
        '.cart__items .cart-item',
        '.cart-drawer__items .cart-item',
        'cart-items .cart-item',
      ];
      var containers = [];
      for (var sel of containerSelectors) {
        var found = document.querySelectorAll(sel);
        if (found.length) {
          containers = Array.from(found);
          break;
        }
      }
      if (!containers.length) return;

      var changed = 0;
      items.forEach(function (item, idx) {
        var container = containers[idx];
        if (!container) return;
        var thumb = pickThumb(item.properties);
        if (!thumb) return;
        var img =
          container.querySelector('.item-image-anchor img') ||
          container.querySelector('.cart-item__image img') ||
          container.querySelector('.item-image img') ||
          container.querySelector('img');
        if (!img) return;
        if (img.dataset.personalisedThumb === thumb) return; /* already done */
        img.src = thumb;
        img.srcset = '';
        img.dataset.personalisedThumb = thumb;
        changed++;
      });
      if (changed) console.log(LOG, 'replaced', changed, 'image(s) with personalised thumbs');
    } catch (e) {
      console.warn(LOG, 'failed:', e);
    }
  }

  /* Schedule a single override after current microtask burst. */
  var pending = null;
  function schedule() {
    if (pending) return;
    pending = setTimeout(function () {
      overrideImages();
      pending = null;
    }, 80);
  }

  function init() {
    schedule();
    /* Watch DOM for drawer open / re-renders. */
    var observer = new MutationObserver(function (records) {
      for (var rec of records) {
        if (rec.addedNodes.length) {
          schedule();
          return;
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });

    /* Also override after typical cart events. */
    document.addEventListener('cart:updated', schedule);
    document.addEventListener('cart:refresh', schedule);
    /* SlideCartHQ doesn't emit a standard event; rely on MutationObserver. */
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
